module.exports = __webpack_public_path__ + "images/3ae810ab0b23e5f6d54c51a6c5d45497-laptop-coffee.jpg";